// Score and Summary section form field enum
export enum ScoreAndSummaryFormField {
  SCORE_AND_SUMMARY_MODIFIER_A = 'scoreAndSummary/modifierA',
  SCORE_AND_SUMMARY_MODIFIER_B = 'scoreAndSummary/modifierB',
  SCORE_AND_SUMMARY_CNA_SKILLED_TASKS = 'scoreAndSummary/cnaSkilledTasks',
  SCORE_AND_SUMMARY_TOTAL = 'scoreAndSummary/total'
}
